
  import { defineComponent, PropType } from 'vue';
  import TpxCheckbox from './checkbox.vue';
  import TpxLabel from './label.vue';
  import TpxTooltip from './tooltip.vue';
  import './checkbox-group.scss';

  /**
    * Checkbox group
    * 
    * @example
    * <code>import TpxCheckboxGroup from '@manifesto-tech/tpximpact-design-system/components/atoms/form/checkbox-group.vue'</code>
    */
  export default defineComponent({
    name: 'TpxCheckboxGroup',
    
    components: {
      TpxCheckbox,
      TpxLabel,
      TpxTooltip,
    },

    emits: [
      'change',
    ],

    props: {
      /**
       * Checkboxes to be displayed within this group
       */
      checkboxes: {
        type: Array as PropType<Array<typeof TpxCheckbox>>,
      },

      /**
       * Label for the group
       */
      label: {
        type: String,
      },

      /**
       * Should at least one of the checkboxes be required?
       */
      isRequired: {
        type: Boolean,
      },

      /**
       * Optional help text
       */
      tooltip: {
        type: String,
      },
    },
  });
